import { openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode, normalizeClass as _normalizeClass, withModifiers as _withModifiers, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-28be4fb0"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "file-upload-box" }
const _hoisted_2 = {
  key: 0,
  class: "wrapper"
}
const _hoisted_3 = ["src"]
const _hoisted_4 = {
  key: 0,
  class: "input"
}
const _hoisted_5 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "label" }, "Cliquez ici pour sélectionner vos fichiers ou glissez-les dans cette zone. ", -1))
const _hoisted_6 = ["accept"]
const _hoisted_7 = { key: 1 }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    ($setup.visible)
      ? (_openBlock(), _createElementBlock("div", _hoisted_2, [
          ($setup.visible)
            ? (_openBlock(), _createElementBlock("div", {
                key: 0,
                class: "back-click",
                onClick: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => ($setup.dismiss && $setup.dismiss(...args)))
              }))
            : _createCommentVNode("", true),
          _createElementVNode("div", {
            class: "file-input",
            onDrop: _cache[2] || (_cache[2] = _withModifiers(
//@ts-ignore
(...args) => ($setup.dropFile && $setup.dropFile(...args)), ["prevent","stop"])),
            onDragover: _cache[3] || (_cache[3] = _withModifiers(($event: any) => ($setup.over=true), ["prevent"])),
            onDragleave: _cache[4] || (_cache[4] = _withModifiers(($event: any) => ($setup.over=false), ["prevent"]))
          }, [
            ($setup.preview)
              ? (_openBlock(), _createElementBlock("img", {
                  key: 0,
                  class: "file-preview",
                  src: $setup.preview
                }, null, 8, _hoisted_3))
              : (_openBlock(), _createElementBlock("div", {
                  key: 1,
                  class: _normalizeClass(["file-zone", {over:$setup.over}])
                }, [
                  (!$setup.over)
                    ? (_openBlock(), _createElementBlock("label", _hoisted_4, [
                        _hoisted_5,
                        _createElementVNode("input", {
                          type: "file",
                          onChange: _cache[1] || (_cache[1] = 
//@ts-ignore
(...args) => ($setup.onChange && $setup.onChange(...args))),
                          accept: $setup.accept
                        }, null, 40, _hoisted_6)
                      ]))
                    : (_openBlock(), _createElementBlock("div", _hoisted_7, " Déposez votre fichier ici "))
                ], 2))
          ], 32)
        ]))
      : _createCommentVNode("", true)
  ]))
}